import React, {useEffect, useState} from 'react';
import {GET_COLLECTION_AGGREGATE_DATA, SEARCH_COLLECTION_URL} from "../../../api";
import 'datatables.net';
import 'datatables.net-responsive';
import 'components-jqueryui';
import 'ion-rangeslider';
import '../../../lib/ion-rangeslider/css/ion.rangeSlider.min.css';
import $ from "jquery";
import 'select2';
import {Link} from "react-router-dom";
import cogoToast from "cogo-toast";
import {qrcode} from "api/app";
import {capitalize} from "utils/capitalize";
import QR from 'qrcode';
const jQuery = window.$;

const generateHtmlContent = (sequentialNumbers, qrCodes, name) => {
    // Function to generate QR pages
    const renderQRPage = (page) => {
        return page.map((item, index) => `
      <div key="${index}" class="a8">
         <div class="logo">
            <div style="margin-right: 4px;">
                <img src="https://i.imgur.com/3GLBcmA.png" height="45" alt="logo"/>
            </div>
            
            <div style="margin-left: 4px;">
                <img src="https://i.imgur.com/cCOlLfA.png" height="45" alt="logo"/>
            </div>
         </div>
        <div class="qrcode">${item.qrCode}</div>
        <h1 class="qrcode-text">${item.randomNumber}</h1>
        <div class="download">
          <div class="android">
                                <svg width="85" height="34" viewBox="0 0 114 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1.21195" y="0.99686" width="111.959" height="32.5852" rx="3.75983" fill="black"/>
                                    <rect x="1.21195" y="0.99686" width="111.959" height="32.5852" rx="3.75983" stroke="#A6A6A6" stroke-width="0.835517"/>
                                    <path d="M90.1398 25.6446H91.6989V15.1993H90.1398V25.6446ZM104.182 18.9621L102.395 23.4905H102.342L100.487 18.9621H98.8074L101.59 25.2912L100.003 28.812H101.629L105.916 18.9621H104.182ZM95.34 24.4582C94.8304 24.4582 94.1177 24.2027 94.1177 23.5712C94.1177 22.765 95.005 22.4559 95.7703 22.4559C96.4555 22.4559 96.7788 22.6035 97.1949 22.8052C97.0737 23.7729 96.2407 24.4582 95.34 24.4582ZM95.5289 18.7336C94.4001 18.7336 93.2312 19.231 92.7474 20.3329L94.131 20.9105C94.4268 20.3329 94.9774 20.1449 95.5556 20.1449C96.3619 20.1449 97.1815 20.6282 97.1949 21.4886V21.5959C96.9125 21.4347 96.3076 21.1929 95.569 21.1929C94.0767 21.1929 92.5586 22.0123 92.5586 23.5443C92.5586 24.9419 93.7818 25.8424 95.152 25.8424C96.1998 25.8424 96.7788 25.372 97.1406 24.8208H97.1949V25.6276H98.7005V21.6227C98.7005 19.7682 97.3152 18.7336 95.5289 18.7336ZM85.8937 20.2336H83.6762V16.6533H85.8937C87.0592 16.6533 87.721 17.6181 87.721 18.4434C87.721 19.2529 87.0592 20.2336 85.8937 20.2336ZM85.8536 15.1993H82.1178V25.6446H83.6762V21.6873H85.8536C87.5814 21.6873 89.28 20.4366 89.28 18.4434C89.28 16.4506 87.5814 15.1993 85.8536 15.1993ZM65.4825 24.4602C64.4054 24.4602 63.504 23.558 63.504 22.3201C63.504 21.0679 64.4054 20.153 65.4825 20.153C66.5459 20.153 67.3804 21.0679 67.3804 22.3201C67.3804 23.558 66.5459 24.4602 65.4825 24.4602ZM67.2727 19.547H67.2188C66.869 19.1298 66.1956 18.7529 65.3481 18.7529C63.5709 18.7529 61.9423 20.3146 61.9423 22.3201C61.9423 24.312 63.5709 25.86 65.3481 25.86C66.1956 25.86 66.869 25.483 67.2188 25.0525H67.2727V25.5636C67.2727 26.9236 66.5459 27.6502 65.3748 27.6502C64.4195 27.6502 63.8272 26.9638 63.5846 26.3851L62.2253 26.9504C62.6154 27.8923 63.6516 29.0503 65.3748 29.0503C67.2058 29.0503 68.7537 27.9733 68.7537 25.3482V18.9683H67.2727V19.547ZM69.8308 25.6446H71.3915V15.1993H69.8308V25.6446ZM73.6935 22.1987C73.6533 20.8257 74.7574 20.1259 75.5512 20.1259C76.1706 20.1259 76.6951 20.4356 76.8707 20.8795L73.6935 22.1987ZM78.5391 21.014C78.2431 20.2202 77.3413 18.7529 75.4973 18.7529C73.6663 18.7529 72.1454 20.1932 72.1454 22.3064C72.1454 24.2987 73.6533 25.86 75.6719 25.86C77.3005 25.86 78.2431 24.8642 78.6337 24.2852L77.4222 23.4774C77.0182 24.0698 76.4666 24.4602 75.6719 24.4602C74.8781 24.4602 74.3126 24.0966 73.9496 23.3832L78.7006 21.418L78.5391 21.014ZM40.6837 19.8433V21.3508H44.291C44.1834 22.1987 43.9007 22.8179 43.4699 23.2487C42.9448 23.7734 42.1236 24.3525 40.6837 24.3525C38.4627 24.3525 36.7264 22.5623 36.7264 20.3413C36.7264 18.1203 38.4627 16.3299 40.6837 16.3299C41.8818 16.3299 42.7565 16.8011 43.4026 17.4069L44.4663 16.3433C43.5642 15.4819 42.3664 14.8224 40.6837 14.8224C37.6412 14.8224 35.0837 17.2992 35.0837 20.3413C35.0837 23.3832 37.6412 25.86 40.6837 25.86C42.3257 25.86 43.5642 25.3215 44.5333 24.312C45.5294 23.3159 45.8391 21.9161 45.8391 20.7852C45.8391 20.4356 45.8119 20.1125 45.7581 19.8433H40.6837ZM49.9403 24.4602C48.8632 24.4602 47.9344 23.5718 47.9344 22.3064C47.9344 21.0277 48.8632 20.153 49.9403 20.153C51.017 20.153 51.9458 21.0277 51.9458 22.3064C51.9458 23.5718 51.017 24.4602 49.9403 24.4602ZM49.9403 18.7529C47.9745 18.7529 46.373 20.247 46.373 22.3064C46.373 24.3525 47.9745 25.86 49.9403 25.86C51.9054 25.86 53.5072 24.3525 53.5072 22.3064C53.5072 20.247 51.9054 18.7529 49.9403 18.7529ZM57.7213 24.4602C56.645 24.4602 55.7158 23.5718 55.7158 22.3064C55.7158 21.0277 56.645 20.153 57.7213 20.153C58.7984 20.153 59.7269 21.0277 59.7269 22.3064C59.7269 23.5718 58.7984 24.4602 57.7213 24.4602ZM57.7213 18.7529C55.7563 18.7529 54.1547 20.247 54.1547 22.3064C54.1547 24.3525 55.7563 25.86 57.7213 25.86C59.6871 25.86 61.2886 24.3525 61.2886 22.3064C61.2886 20.247 59.6871 18.7529 57.7213 18.7529Z" fill="white"/>
                                    <path d="M37.9556 11.6367C37.2065 11.6367 36.5622 11.3731 36.0427 10.8537C35.523 10.334 35.2598 9.68322 35.2598 8.92651C35.2598 8.16979 35.5231 7.52017 36.0427 6.99927C36.5622 6.47978 37.2065 6.2163 37.9556 6.2163C38.3372 6.2163 38.6934 6.28221 39.0338 6.41947C39.3743 6.55674 39.6529 6.74729 39.8722 6.99666L39.924 7.05557L39.3396 7.63978L39.2812 7.56798C39.1357 7.38922 38.9507 7.25035 38.7162 7.1494C38.4826 7.04871 38.2268 7.00221 37.9556 7.00221C37.428 7.00221 36.9902 7.18138 36.6247 7.54562C36.6246 7.5457 36.6244 7.5457 36.6243 7.54579C36.2671 7.91738 36.0874 8.36979 36.0874 8.92651C36.0874 9.48366 36.2673 9.93617 36.625 10.3079C36.9905 10.672 37.4283 10.8521 37.9556 10.8521C38.4386 10.8521 38.838 10.7173 39.1521 10.4504H39.1523C39.4446 10.2019 39.6201 9.86621 39.6821 9.43827H37.8721V8.66802H40.4644L40.4755 8.73852C40.4968 8.87392 40.5118 9.00462 40.5118 9.13017C40.5118 9.84886 40.2927 10.4355 39.8628 10.8671C39.3775 11.3816 38.7393 11.6367 37.9556 11.6367L37.9556 11.6367ZM60.4659 11.6367C59.7157 11.6367 59.0789 11.373 58.5661 10.8537C58.5661 10.8537 58.566 10.8537 58.5659 10.8536C58.5659 10.8535 58.5659 10.8535 58.5658 10.8534C58.0523 10.3397 57.7975 9.68881 57.7975 8.9265C57.7975 8.16418 58.0523 7.51326 58.5658 6.99959C58.5658 6.99953 58.5659 6.99951 58.5659 6.99942L58.5661 6.99925C59.0789 6.4799 59.7157 6.21628 60.4659 6.21628C61.2147 6.21628 61.8517 6.47996 62.3645 7.00709C62.8781 7.52068 63.1331 8.17037 63.1331 8.92649C63.1331 9.68881 62.8783 10.3397 62.3648 10.8534L62.3646 10.8536C61.8515 11.3732 61.2086 11.6367 60.4659 11.6367L60.4659 11.6367ZM41.2536 11.5244V6.32857H41.3372H44.3568V7.11448H42.0669V8.54139H44.1322V9.31163H42.0669V10.7398H44.3568V11.5244H41.2536ZM46.2559 11.5244V7.11448H44.8512V6.32857H48.474V7.11448H48.3904H47.0693V11.5244H46.2559ZM50.7893 11.5244V6.32857H51.6026V6.41212V11.5244H50.7893ZM53.6499 11.5244V7.11448H52.2452V6.32857H55.868V7.11448H55.7844H54.4633V11.5244H53.6499ZM63.855 11.5244V6.32857H64.7721L67.1062 10.0652L67.0861 9.35585V6.32857H67.8994V11.5244H67.0946L64.6483 7.59898L64.6683 8.30786V8.30901V11.5244H63.855ZM60.4659 10.8521C60.9935 10.8521 61.4242 10.6722 61.7753 10.3085L61.7758 10.3079L61.7764 10.3074C62.1325 9.95118 62.3067 9.49265 62.3067 8.92648C62.3067 8.36169 62.1324 7.90162 61.7764 7.54559L61.7758 7.54509L61.7753 7.54459C61.4243 7.18103 60.9937 7.00216 60.4659 7.00216C59.9373 7.00216 59.5067 7.18072 59.149 7.54426L59.1487 7.5446C58.7992 7.90926 58.6252 8.36185 58.6252 8.92646C58.6252 9.49246 58.7991 9.9436 59.1487 10.3083L59.149 10.3087C59.5068 10.6723 59.9374 10.8521 60.4659 10.8521V10.8521Z" fill="white"/>
                                    <path d="M18.1016 16.8077L9.2063 26.2491C9.20663 26.251 9.2073 26.2527 9.20764 26.2546C9.48043 27.2798 10.4168 28.0347 11.5281 28.0347C11.9724 28.0347 12.3895 27.9146 12.7471 27.7037L12.7755 27.6871L22.7884 21.9093L18.1016 16.8077Z" fill="#EA4335"/>
                                    <path d="M27.1009 15.1999L27.0924 15.1941L22.7696 12.6881L17.8994 17.0218L22.7865 21.9082L27.0865 19.4271C27.8404 19.0202 28.3521 18.2254 28.3521 17.3089C28.3521 16.3991 27.8472 15.6082 27.1009 15.1999Z" fill="#FBBC04"/>
                                    <path d="M9.20585 8.32976C9.15237 8.52695 9.12427 8.73348 9.12427 8.94796V25.6312C9.12427 25.8453 9.15204 26.0525 9.20618 26.249L18.4076 17.0492L9.20585 8.32976Z" fill="#4285F4"/>
                                    <path d="M18.1671 17.2896L22.7713 12.6867L12.7698 6.88803C12.4063 6.6703 11.982 6.54464 11.528 6.54464C10.4166 6.54464 9.47902 7.30087 9.20614 8.3273C9.20581 8.3283 9.20581 8.32897 9.20581 8.32989L18.1671 17.2896Z" fill="#34A853"/>
                                </svg>
          </div>
          <div class="ios">
                                <svg width="85" height="34" viewBox="0 0 102 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1.36185" y="0.99686" width="99.4265" height="32.5852" rx="5.43086" fill="black"/>
                                    <rect x="1.36185" y="0.99686" width="99.4265" height="32.5852" rx="5.43086" stroke="#A6A6A6" stroke-width="0.835517"/>
                                    <path d="M69.0605 16.6219V18.5361H67.8606V19.7914H69.0605V24.0567C69.0605 25.5132 69.7193 26.0957 71.3769 26.0957C71.6682 26.0957 71.9456 26.0611 72.1883 26.0194V24.778C71.9803 24.7988 71.8485 24.8127 71.6196 24.8127C70.8775 24.8127 70.5516 24.4659 70.5516 23.6753V19.7914H72.1883V18.5361H70.5516V16.6219H69.0605Z" fill="white"/>
                                    <path d="M76.4109 26.1998C78.6164 26.1998 79.9688 24.7225 79.9688 22.2743C79.9688 19.84 78.6095 18.3558 76.4109 18.3558C74.2055 18.3558 72.8461 19.84 72.8461 22.2743C72.8461 24.7225 74.1985 26.1998 76.4109 26.1998ZM76.4109 24.8751C75.114 24.8751 74.3858 23.9249 74.3858 22.2743C74.3858 20.6375 75.114 19.6804 76.4109 19.6804C77.7009 19.6804 78.4361 20.6375 78.4361 22.2743C78.4361 23.918 77.7009 24.8751 76.4109 24.8751Z" fill="white"/>
                                    <path d="M81.1259 26.0541H82.617V21.5946C82.617 20.5335 83.4146 19.8192 84.5451 19.8192C84.8086 19.8192 85.2525 19.8677 85.3773 19.9093V18.439C85.2178 18.3974 84.9335 18.3766 84.7115 18.3766C83.7267 18.3766 82.8875 18.9175 82.6725 19.6596H82.5615V18.5014H81.1259V26.0541Z" fill="white"/>
                                    <path d="M89.0798 19.625C90.1825 19.625 90.9038 20.3948 90.9385 21.5808H87.124C87.2072 20.4017 87.977 19.625 89.0798 19.625ZM90.9315 24.0151C90.6541 24.6046 90.0368 24.9306 89.1352 24.9306C87.9423 24.9306 87.1725 24.0914 87.124 22.7667V22.6835H92.4573V22.1633C92.4573 19.7914 91.1881 18.3558 89.0867 18.3558C86.9575 18.3558 85.6051 19.8885 85.6051 22.302C85.6051 24.7156 86.9298 26.1998 89.0936 26.1998C90.8205 26.1998 92.0273 25.3675 92.3672 24.0151H90.9315Z" fill="white"/>
                                    <path d="M59.2819 23.265C59.3969 25.1196 60.9424 26.3057 63.2427 26.3057C65.7011 26.3057 67.2395 25.0621 67.2395 23.0781C67.2395 21.5182 66.3625 20.6556 64.2347 20.1596L63.0918 19.8793C61.7403 19.563 61.194 19.1389 61.194 18.3985C61.194 17.464 62.0423 16.853 63.3146 16.853C64.5223 16.853 65.3561 17.4496 65.5071 18.4057H67.0741C66.9807 16.6589 65.4424 15.4297 63.3362 15.4297C61.0718 15.4297 59.5623 16.6589 59.5623 18.5063C59.5623 20.0303 60.4177 20.936 62.2939 21.3745L63.6309 21.698C65.0039 22.0214 65.6077 22.4959 65.6077 23.2866C65.6077 24.2067 64.6588 24.8752 63.3649 24.8752C61.9776 24.8752 61.0143 24.2498 60.8777 23.265H59.2819Z" fill="white"/>
                                    <path d="M43.8354 18.3766C42.809 18.3766 41.9213 18.8898 41.4635 19.7498H41.3526V18.5014H39.9169V28.5647H41.408V24.9098H41.5259C41.9213 25.7073 42.7743 26.179 43.8493 26.179C45.7566 26.179 46.9703 24.674 46.9703 22.2743C46.9703 19.8746 45.7566 18.3766 43.8354 18.3766ZM43.4124 24.8404C42.164 24.8404 41.3803 23.8556 41.3803 22.2812C41.3803 20.7 42.164 19.7151 43.4193 19.7151C44.6816 19.7151 45.4375 20.6791 45.4375 22.2743C45.4375 23.8764 44.6816 24.8404 43.4124 24.8404Z" fill="white"/>
                                    <path d="M52.1879 18.3766C51.1615 18.3766 50.2738 18.8898 49.816 19.7498H49.705V18.5014H48.2694V28.5647H49.7605V24.9098H49.8784C50.2738 25.7073 51.1268 26.179 52.2018 26.179C54.1091 26.179 55.3228 24.674 55.3228 22.2743C55.3228 19.8746 54.1091 18.3766 52.1879 18.3766ZM51.7649 24.8404C50.5165 24.8404 49.7328 23.8556 49.7328 22.2812C49.7328 20.7 50.5165 19.7151 51.7718 19.7151C53.0341 19.7151 53.79 20.6791 53.79 22.2743C53.79 23.8764 53.0341 24.8404 51.7649 24.8404Z" fill="white"/>
                                    <path d="M37.2416 26.0541H38.9524L35.2073 15.6813H33.4749L29.7297 26.0541H31.3831L32.3391 23.301H36.2927L37.2416 26.0541ZM34.2584 17.5646H34.3806L35.883 21.9495H32.7489L34.2584 17.5646Z" fill="white"/>
                                    <path d="M30.7312 7.85705V12.861H32.5379C34.029 12.861 34.8925 11.942 34.8925 10.3434C34.8925 8.76906 34.0221 7.85705 32.5379 7.85705H30.7312ZM31.508 8.56446H32.4512C33.488 8.56446 34.1018 9.22333 34.1018 10.3538C34.1018 11.5016 33.4984 12.1536 32.4512 12.1536H31.508V8.56446Z" fill="white"/>
                                    <path d="M37.537 12.9338C38.6397 12.9338 39.3159 12.1952 39.3159 10.9711C39.3159 9.75389 38.6362 9.0118 37.537 9.0118C36.4342 9.0118 35.7545 9.75389 35.7545 10.9711C35.7545 12.1952 36.4307 12.9338 37.537 12.9338ZM37.537 12.2715C36.8885 12.2715 36.5244 11.7964 36.5244 10.9711C36.5244 10.1527 36.8885 9.67413 37.537 9.67413C38.1819 9.67413 38.5495 10.1527 38.5495 10.9711C38.5495 11.7929 38.1819 12.2715 37.537 12.2715Z" fill="white"/>
                                    <path d="M45.0744 9.08462H44.3288L43.6561 11.9663H43.5971L42.8204 9.08462H42.106L41.3292 11.9663H41.2738L40.5976 9.08462H39.8416L40.8819 12.861H41.6483L42.425 10.0799H42.484L43.2642 12.861H44.0375L45.0744 9.08462Z" fill="white"/>
                                    <path d="M45.933 12.861H46.6786V10.652C46.6786 10.0625 47.0288 9.69494 47.5802 9.69494C48.1315 9.69494 48.3951 9.99663 48.3951 10.6035V12.861H49.1406V10.4162C49.1406 9.51809 48.676 9.0118 47.8333 9.0118C47.2646 9.0118 46.8901 9.26494 46.7063 9.68454H46.6508V9.08462H45.933V12.861Z" fill="white"/>
                                    <path d="M50.3148 12.861H51.0604V7.61084H50.3148V12.861Z" fill="white"/>
                                    <path d="M53.8644 12.9338C54.9671 12.9338 55.6433 12.1952 55.6433 10.9711C55.6433 9.75389 54.9636 9.0118 53.8644 9.0118C52.7616 9.0118 52.082 9.75389 52.082 10.9711C52.082 12.1952 52.7582 12.9338 53.8644 12.9338ZM53.8644 12.2715C53.2159 12.2715 52.8518 11.7964 52.8518 10.9711C52.8518 10.1527 53.2159 9.67413 53.8644 9.67413C54.5094 9.67413 54.8769 10.1527 54.8769 10.9711C54.8769 11.7929 54.5094 12.2715 53.8644 12.2715Z" fill="white"/>
                                    <path d="M57.8647 12.2957C57.459 12.2957 57.1642 12.0981 57.1642 11.7582C57.1642 11.4253 57.4001 11.2485 57.9202 11.2138L58.8426 11.1549V11.4704C58.8426 11.9386 58.4265 12.2957 57.8647 12.2957ZM57.674 12.9234C58.1699 12.9234 58.5825 12.7084 58.8079 12.3304H58.8669V12.861H59.5847V10.281C59.5847 9.48341 59.0507 9.0118 58.104 9.0118C57.2475 9.0118 56.6372 9.42793 56.5609 10.0764H57.2822C57.3654 9.80938 57.6532 9.6568 58.0693 9.6568C58.5791 9.6568 58.8426 9.8822 58.8426 10.281V10.607L57.8196 10.6659C56.9215 10.7214 56.4152 11.1132 56.4152 11.7929C56.4152 12.483 56.9458 12.9234 57.674 12.9234Z" fill="white"/>
                                    <path d="M62.1148 12.9234C62.6349 12.9234 63.0753 12.6772 63.3007 12.2645H63.3597V12.861H64.074V7.61084H63.3285V9.68454H63.273C63.0684 9.26841 62.6315 9.0222 62.1148 9.0222C61.1611 9.0222 60.5474 9.77817 60.5474 10.9711C60.5474 12.1674 61.1542 12.9234 62.1148 12.9234ZM62.3263 9.69147C62.9505 9.69147 63.3423 10.1874 63.3423 10.9745C63.3423 11.7652 62.954 12.2541 62.3263 12.2541C61.6952 12.2541 61.3172 11.7721 61.3172 10.9711C61.3172 10.177 61.6986 9.69147 62.3263 9.69147Z" fill="white"/>
                                    <path d="M68.9087 12.9338C70.0115 12.9338 70.6877 12.1952 70.6877 10.9711C70.6877 9.75389 70.008 9.0118 68.9087 9.0118C67.806 9.0118 67.1263 9.75389 67.1263 10.9711C67.1263 12.1952 67.8025 12.9338 68.9087 12.9338ZM68.9087 12.2715C68.2603 12.2715 67.8962 11.7964 67.8962 10.9711C67.8962 10.1527 68.2603 9.67413 68.9087 9.67413C69.5537 9.67413 69.9213 10.1527 69.9213 10.9711C69.9213 11.7929 69.5537 12.2715 68.9087 12.2715Z" fill="white"/>
                                    <path d="M71.6746 12.861H72.4201V10.652C72.4201 10.0625 72.7704 9.69494 73.3218 9.69494C73.8731 9.69494 74.1367 9.99663 74.1367 10.6035V12.861H74.8822V10.4162C74.8822 9.51809 74.4175 9.0118 73.5749 9.0118C73.0062 9.0118 72.6317 9.26494 72.4479 9.68454H72.3924V9.08462H71.6746V12.861Z" fill="white"/>
                                    <path d="M78.316 8.14487V9.10196H77.716V9.72962H78.316V11.8623C78.316 12.5905 78.6454 12.8818 79.4742 12.8818C79.6198 12.8818 79.7585 12.8644 79.8799 12.8436V12.2229C79.7759 12.2333 79.71 12.2402 79.5955 12.2402C79.2245 12.2402 79.0615 12.0669 79.0615 11.6715V9.72962H79.8799V9.10196H79.0615V8.14487H78.316Z" fill="white"/>
                                    <path d="M80.8807 12.861H81.6262V10.6555C81.6262 10.0833 81.9661 9.69841 82.5764 9.69841C83.1035 9.69841 83.3844 10.0036 83.3844 10.607V12.861H84.1299V10.4232C84.1299 9.52502 83.6341 9.01527 82.8295 9.01527C82.2608 9.01527 81.862 9.26841 81.6783 9.69147H81.6193V7.61084H80.8807V12.861Z" fill="white"/>
                                    <path d="M86.8195 9.64639C87.3709 9.64639 87.7315 10.0313 87.7489 10.6243H85.8416C85.8832 10.0348 86.2681 9.64639 86.8195 9.64639ZM87.7454 11.8415C87.6067 12.1362 87.298 12.2992 86.8472 12.2992C86.2508 12.2992 85.8659 11.8796 85.8416 11.2173V11.1757H88.5083V10.9156C88.5083 9.72962 87.8737 9.0118 86.823 9.0118C85.7584 9.0118 85.0822 9.77817 85.0822 10.9849C85.0822 12.1917 85.7445 12.9338 86.8264 12.9338C87.6899 12.9338 88.2933 12.5177 88.4632 11.8415H87.7454Z" fill="white"/>
                                    <path d="M21.639 17.5408C21.6571 16.1363 22.4114 14.8073 23.608 14.0717C22.8531 12.9936 21.5887 12.3101 20.2733 12.2689C18.8703 12.1217 17.5101 13.1085 16.7951 13.1085C16.0663 13.1085 14.9655 12.2835 13.7802 12.3079C12.2351 12.3579 10.7947 13.2363 10.043 14.5871C8.42708 17.3848 9.63239 21.4964 11.1803 23.7578C11.9547 24.8652 12.8598 26.1021 14.0441 26.0582C15.203 26.0102 15.6359 25.3192 17.0348 25.3192C18.4207 25.3192 18.8268 26.0582 20.0351 26.0304C21.2787 26.0102 22.0622 24.9181 22.8094 23.8002C23.3659 23.0112 23.7941 22.1392 24.0781 21.2164C22.6167 20.5983 21.6407 19.1276 21.639 17.5408Z" fill="white"/>
                                    <path d="M19.3567 10.7817C20.0347 9.96774 20.3688 8.92152 20.2879 7.86523C19.252 7.97404 18.2951 8.46913 17.6079 9.25187C16.9359 10.0166 16.5862 11.0444 16.6523 12.0604C17.6886 12.071 18.7073 11.5894 19.3567 10.7817Z" fill="white"/>
                                </svg>
</div>
        </div>
        <a href="https://www.ebusaka.com">www.ebusaka.com</a>
      </div>
    `).join('');
    };

    // Function to render QR pages
    const renderQRPages = () => {
        const pageSize = 16; // Number of QR codes per A4 page
        let html = '';

        for (let i = 0; i < sequentialNumbers.length; i += pageSize) {
            const page = sequentialNumbers.slice(i, i + pageSize).map((number, index) => ({
                qrCode: qrCodes[i + index],
                randomNumber: number.randomNumber
            }));

            html += `
        <div key="${i}" class="a4">
          ${renderQRPage(page)}
        </div>
      `;
        }

        return html;
    };

    // HTML content structure
    return `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>${name} - QR Code</title>
          <style>
            body {
                background: gray;
                margin: 0;
                padding: 0;
                font-family: Arial, sans-serif;
            }
        
            .a4 {
              width: 210mm;
              height: 297mm;
              display: grid;
              grid-template-columns: repeat(4, 52.5mm);
              grid-template-rows: repeat(4, 74.25mm);
              background: white;
              margin: auto;
              page-break-after: always;
              box-sizing: border-box;
              border: 0.1px dashed #6e6e6e;
            }
            
            .a8 {
              box-sizing: border-box;
              padding: 5px;
              text-align: center;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            
              border-right: 0.3px dashed #6e6e6e;
              border-bottom: 0.3px dashed #6e6e6e;
            }
            
            .a8:nth-child(4n) {
              border-right: none;
            }
           
            .a8:nth-last-child(-n + 4) {
              border-bottom: none;
            }
        
            .qrcode-text {
                font-size: 9px;
                margin-top: 3px;
            }
        
            .qrcode {
                margin: 3px auto;
                width: 70%;
                height: auto;
            }
            
            .logo {
                display: flex;
                justify-content: center;
            }
        
            .download {
                display: flex;
                justify-content: center;
                margin-bottom: 3px;
            }
        
            .android {
                margin-right: 3px;
            }
        
            .ios {
                margin-left: 3px;
            }
        
            a {
                text-decoration: none;
                color: black;
                font-size: 10px;
            }
          </style>
        </head>
        <body>
          ${renderQRPages()}
        </body>
        </html>
    `;
};

const QRCode = () => {

    document.title = "QR Code";

    const [stateReady, setStateReady] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [editId, setEditId] = useState(0);
    const [qrCode, setQRCode] = useState(null);
    const [range, setRange] = useState({ from: 0, to: 0 });

    const token = localStorage.getItem('jwtToken');

    useEffect(() => {
        let table = $('#qrcode').DataTable({
            responsive: true,
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting QR Code Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "qrcode",
                        searchableFields: [
                            { field: 'area_code', isNumeric: false },
                            { field: 'collector.name', isNumeric: false }
                        ],
                        pageSize: data.start,
                        populate: [
                            {
                                path: 'collector',
                                model: 'collector',
                                populate: {
                                    path: 'country',
                                    model: 'country'
                                }

                            }
                        ],
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success : function(res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.area_code;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return `<div class="d-flex">
                            <div class="avatar wd-20 ht-20"><img src="${data.collector.logo_uri}" class="rounded-circle" alt="logo"></div>
                            <span class="pd-x-5">${capitalize(data.collector.name)}</span>
                        </div>`;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        const activeCount = data.data.filter(item => item.active === true).length;
                        return `${activeCount}/${data.data.length}`;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return data.prefix;
                    },
                    "targets": 3
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link view_qrcode"><i class="fa fa-eye"></i> View</a><a href="#" class="nav-link edit_qrcode"><i class="fa fa-pencil"></i> Edit</a><a href="#" class="nav-link print"><i class="fa fa-print"></i> Print</a><a href="#" class="nav-link extension"><i class="fa fa-plus"></i> Extend</a><a href="#" class="nav-link delete_qrcode"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                    },
                    "targets": 4
                }
            ]
        });

        table.on('click', '.view_qrcode', function(e) {
            e.preventDefault();

            let extract_td = table.row($(this).closest('tr')).data();

            let qr_codes = [];

            extract_td.raw.data.map((item) => {
                qr_codes.push([extract_td.raw.area_code, item.code_number, item.active, item?.place?.ori_address ? item.place.ori_address : false])
            });

            $('#qrcode_table').DataTable({
                responsive: true,
                searching: true,
                lengthMenu: [[10], [10]],
                ordering: false,
                info: true,
                bFilter: false,
                pageLength: 10,
                data: qr_codes,
                columns: [
                    { title: 'Area Code' },
                    { title: 'Number' },
                    { title: 'Status' },
                    { title: 'Address' }
                ],
                columnDefs: [
                    {
                        "render": function (data) {
                            return {
                                true : `<span class="badge badge-success tx-white">Activated</span>`,
                                false : `<span class="badge badge-danger tx-white">Unassigned</span>`
                            }[data];
                        },
                        "targets": 2
                    },
                    {
                        "render": function (data) {
                            if(data) {
                                const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(data)}`;
                                return `<nav class="nav nav-icon-only"><a href="${googleMapsLink}" class="nav-link view-map" target="_blank">${data}</a></nav>`;
                            }
                            return "No Address";
                        },
                        "targets": 3
                    }
                ]
            });

            $("#modalQRCodeList").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.delete_qrcode', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();
            $(".data-message").text(`Are you sure, you want to delete, ${capitalize(extract_td.raw.collector.name)} QR Code?`);
            $('#delete-qrcode').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 3
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                qrcode("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("QR Code successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.print', async function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();
            setQRCode(extract_td.raw);

            let total = extract_td.raw.data.length;

            jQuery("#range").ionRangeSlider({
                type: 'double',
                grid: true,
                min: 0,
                max: total,
                from: 0,
                to: total >= 1000 ? 1000 : total,
                max_interval: total >= 1000 ? 1000 : total,
                onStart: function (data) {
                    setRange({ from: data.from, to: data.to });
                },
                onFinish: function (data) {
                    setRange({ from: data.from, to: data.to });
                }
            });

            $("#modalPrint").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.extension', async function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();
            setEditId(extract_td.raw._id);

            $('#extension_form').parsley();
            $("#modalExtension").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.edit_qrcode', function(e) {
            e.preventDefault();

            initializeCollectorSearch();

            let area_code = $("#area-code");
            let prefix = $("#prefix");
            let description = $("#description");
            let count = $("#count");
            let collector_select = $("#collector-select2");

            let extract_td = table.row($(this).closest('tr')).data();

            setEditForm(true);
            setEditId(extract_td.raw._id);

            $('#qrcode_form').parsley();

            prefix.val(extract_td.raw.prefix);
            area_code.val(extract_td.raw.area_code).prop("disabled", true).prop("required", false);
            description.val(extract_td.raw.description);
            count.val(extract_td.raw.data.length).prop("disabled", true).prop("required", false);

            let $option = $("<option selected></option>").val(extract_td.raw.collector._id).text(extract_td.raw.collector.name);
            collector_select.append($option).trigger('change');

            $("#modalQRCode").modal("show");
        });

        return () => {
            table.destroy();
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        setStateReady(true);

        if(editForm) {
            let data = {
                id: editId,
                collector: $('#collector-select2').val()[0],
                description: $('#description').val()
            };

            qrcode("put", data).then((result) => {
                setStateReady(false);

                if(!result.error) {
                    cogoToast.success("Data successfully updated.", {position: "top-right", hideAfter: 5});
                    resetForm("modalQRCode", "qrcode_form");
                    reloadTable();
                }
            });

            return false;
        }

        let data = {
            area_code: $('#area-code').val(),
            prefix: $('#prefix').val() || "EB",
            count: $('#count').val(),
            description: $('#description').val(),
            collector: $('#collector-select2').val()[0],
        };

        qrcode("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Data successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalQRCode", "qrcode_form");
                reloadTable();
            }
        });
    };

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const handleShowModal = () => {
        setEditForm(false);
        $('#collector-select2').prop("disabled", false).prop("required", true);
        $('#area-code').prop("disabled", false).prop("required", true);
        $('#description').prop("disabled", false).prop("required", true);
        $('#count').prop("disabled", false).prop("required", true);
        initializeCollectorSearch();
        $('#qrcode_form').parsley();
        $("#modalQRCode").modal({ backdrop: 'static', focus: false, show: true });
    };

    const initializeCollectorSearch = () => {
        let modalQRCode = $('#modalQRCode');
        $('#collector-select2').select2({
            placeholder: 'Select garbage collector or type name',
            allowClear: true,
            width:"100%",
            maximumSelectionLength: 1,
            dropdownParent: modalQRCode,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization": token,
                },
                data: function(query) {
                    return {
                        query: query,
                        collection: "collector"
                    };
                },
                processResults: function(data) {
                    return {
                        results: $.map(data, function(item) {
                            return {
                                text: capitalize(item.name),
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $(".select2-search__field").css({display: "none"});
        }).on('select2:unselect', function(e) {
            $(".select2-search__field").css({display: "inline-block"});
        });
    }

    const reloadTable = () => {
        $('#qrcode').DataTable().ajax.reload(null, false);
    };

    const generateQRCode = async (url) => {
        try {
            return await QR.toString(url, { type: 'svg', errorCorrectionLevel: 'M', margin: 0, padding: 0 });
        } catch (error) {
            return null;
        }
    };

    const handlePrintSubmit = async(e) => {
        e.preventDefault();
        let sequentialNumbers = [];
        let qrCodes = [];

        const generateSequentialNumbers = () => {
            const numbers = [];
            let start = range.from;
            let end = range.to;

            qrCode.data.slice(start, end).map((item) => {
                const formattedNumber = item.code_number <= 999 ? item.code_number.toString().padStart(4, '0') : item.code_number.toString();
                numbers.push({ randomNumber: `${qrCode.prefix}-${qrCode.area_code}-${formattedNumber}` });
            });

            return numbers;
        };

        const numbers = generateSequentialNumbers();
        sequentialNumbers = numbers;

        const generateQRCodes = async () => {
            qrCodes = await Promise.all(numbers.map(number => generateQRCode(`https://www.ebusaka.com/qrcodes/${number.randomNumber}`)));
        };

        await generateQRCodes();
        const htmlContent = generateHtmlContent(sequentialNumbers, qrCodes, qrCode.collector.name);
        const newWindow = window.open();
        newWindow.document.open();
        newWindow.document.write(htmlContent);
        newWindow.document.close();
    }

    const handleExtensionSubmit = (e) => {
        e.preventDefault();

        setStateReady(true);

        let data = {
            id: editId,
            count: $('#extension-count').val()
        };

        qrcode("patch", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Data successfully extended.", {position: "top-right", hideAfter: 5});
                resetForm("modalExtension", "extension_form");
                reloadTable();
            }
        });
    }

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                                <li className="breadcrumb-item active" aria-current="page">QR Code</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">QR Code</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <button className="btn btn-sm pd-x-15 btn-success btn-uppercase mg-l-5 outline-none"
                                onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-plus"></i> Generate QR Code
                        </button>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">QR Code List</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable.bind()} className="link-03 lh-0"><i
                                        className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="qrcode" className="table">
                                    <thead>
                                    <tr>
                                        <th className="wd-20p">Area Code</th>
                                        <th className="wd-20p">Collector</th>
                                        <th className="wd-20p">Activation</th>
                                        <th className="wd-10p">Prefix</th>
                                        <th className="wd-30p">Actions</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalQRCode" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15"
                                       data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="#" role="button"
                                                                   className="close pos-absolute t-15 r-15"
                                                                   data-dismiss="modal"
                                                                   onClick={resetForm.bind(null, "modalQRCode", "qrcode_form")}
                                                                   aria-label="Close"><span aria-hidden="true">×</span></a>
                                        <h4 className="tx-18 tx-sm-20 mg-b-2">{editForm ? "Edit QRCode" : "Create QRCode"}</h4>
                                        <p className="tx-13 tx-color-02 mg-b-0">{editForm ? "Edit" : "Create"} QRCode
                                            information.</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="qrcode_form" className="parsley-style-1" onSubmit={handleSubmit.bind()}>
                                        <div id="areaCodeWrapper" className="form-group parsley-input">
                                            <label>Area Code<span className="tx-danger">*</span></label>
                                            <input id="area-code" type="string" className="form-control"
                                                   placeholder="Enter area code"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#areaCodeWrapper" required/>
                                        </div>

                                        <div id="prefixWrapper" className="form-group parsley-input">
                                            <label>Prefix(Optional)</label>
                                            <input id="prefix" type="string" className="form-control"
                                                   placeholder="Enter prefix name"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#prefixWrapper"/>
                                        </div>

                                        <div id="collectorWrapper" className="form-group parsley-input">
                                            <div className="d-flex justify-content-between">
                                                <label>Garbage Collector<span className="tx-danger">*</span></label>
                                            </div>
                                            <select className="form-control" id="collector-select2" data-width="100%"
                                                    multiple="multiple"
                                                    data-parsley-class-handler="#collectorWrapper"
                                                    data-parsley-errors-container="#collectorWrapper"
                                                    autoComplete="off"
                                                    required>
                                            </select>
                                        </div>

                                        <div id="countWrapper" className="form-group parsley-input">
                                            <label>Count<span className="tx-danger">*</span></label>
                                            <input id="count" type="number" className="form-control"
                                                   placeholder="Enter total count"
                                                   autoComplete="none"
                                                   data-parsley-type="digits"
                                                   pattern="\d*"
                                                   data-parsley-class-handler="#countWrapper" required/>
                                        </div>

                                        <div id="descriptionWrapper" className="form-group parsley-input">
                                            <label
                                                className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Description</label>
                                            <textarea id="description" rows="5" className="form-control"
                                                      placeholder="Provide a description"
                                                      data-parsley-class-handler="#descriptionWrapper"
                                                      required></textarea>
                                        </div>

                                        {stateReady ? <button disabled className="btn btn-success btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : editForm ? <button className="btn btn-success btn-block">Update QR Code</button> : <button className="btn btn-success btn-block">Generate QR Code</button>}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalPrint" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15"
                                       data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalPrint", "print_form")} aria-label="Close"><span aria-hidden="true">×</span></a>
                                        <h4 className="tx-18 tx-sm-20 mg-b-2">Generate QR Code</h4>
                                        <p className="tx-13 tx-color-02 mg-b-0">Select the range between 1000 max interval.</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="print_form" onSubmit={handlePrintSubmit.bind()}>
                                        <div id="startFromWrapper" className="form-group">
                                            <input id="range" type="number" className="form-control"
                                                   placeholder="Enter number"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#startFromWrapper" required/>
                                        </div>

                                        <button className="btn btn-success btn-block">Generate</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalExtension" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15"
                                       data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalExtension", "extension_form")} aria-label="Close"><span aria-hidden="true">×</span></a>
                                        <h4 className="tx-18 tx-sm-20 mg-b-2">Extension</h4>
                                        <p className="tx-13 tx-color-02 mg-b-0">Extension information.</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="extension_form" className="parsley-style-1" onSubmit={handleExtensionSubmit.bind()}>
                                        <div id="extendCountWrapper" className="form-group parsley-input">
                                            <label>Count<span className="tx-danger">*</span></label>
                                            <input id="extension-count" type="number" className="form-control"
                                                   placeholder="Enter number"
                                                   autoComplete="none"
                                                   data-parsley-type="digits"
                                                   pattern="\d*"
                                                   data-parsley-class-handler="#extendCountWrapper" required/>
                                        </div>

                                        {stateReady ? <button disabled className="btn btn-success btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> :
                                            <button className="btn btn-success btn-block">Extend</button>}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog"
                         aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p className="mg-b-0 data-message">Empty</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" id="delete-qrcode" className="btn btn-success btn-block">Yes,
                                        Delete
                                    </button>
                                    <button type="button" className="btn btn-danger btn-block mt-0"
                                            data-dismiss="modal">Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalQRCodeList" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={() => $('#qrcode_table').DataTable().destroy()} aria-label="Close"><span aria-hidden="true">×</span></a>
                                        <h4 className="tx-18 tx-sm-20 mg-b-2">QRCode List</h4>
                                        <p className="tx-13 tx-color-02 mg-b-0">List of QRCode activation.</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <table id="qrcode_table" className="table" style={{width: "100%"}}></table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default QRCode;
